import { RouteLoadingData, StateData } from "./prerequisite-loading-service";
const loadPrerequisitesResolveKey = "_sd_loadPrerequisites_";
export class RouteResolveWrapper {
  // @ngInject
  constructor(private $injector: ng.auto.IInjectorService) {}

  private getResolveWrapper = (routeData: RouteLoadingData, resolveKey: string) => {
    let suppliedParameters: string[] = ["$q"];
    if (routeData.stateData.name.includes(".")) {
      /**
       * Injecting this parameter ensures that ui-router will load the parent resolve first, which will
       * also have a field with the same name in its resolve object. This indicates to ui-router that it
       * must first load the parent, so that it can inject it into the child.
       */
      suppliedParameters.push(loadPrerequisitesResolveKey);
    }
    let parametersToRemoveLength: number = suppliedParameters.length;
    let namedArguments: string[] = [];
    if (resolveKey) {
      // let ui-router inject the params, which we will pass onto the real resolve.
      let resolveObj = routeData.originalResolve[resolveKey];
      if (angular.isArray(resolveObj)) {
        namedArguments = routeData.originalResolve[resolveKey].slice(0, resolveObj.length - 1);
      } else {
        namedArguments = this.$injector.annotate(resolveObj);
      }
      suppliedParameters = suppliedParameters.concat(namedArguments);
    }
    let wrapper = function ($q: ng.IQService) {
      // this function will be called with more parameters than just $q, but $q should be the first argument.
      let wrapperArgs = Array.from(arguments).slice(parametersToRemoveLength, arguments.length); // cut $q and loadPrerequisitesResolveKey off
      let deferred = routeData.deferral;
      if (!deferred) {
        deferred = $q.defer();
        routeData.deferral = deferred;
      }
      let originalResolveFn = routeData.originalResolve ? routeData.originalResolve[resolveKey] : undefined;
      return deferred.promise.then(() =>
        routeData.loadPrerequisitesCallback(namedArguments, wrapperArgs, originalResolveFn)
      );
    };
    suppliedParameters.push(<any>wrapper);
    return suppliedParameters;
  };

  public wrapResolve(stateData: StateData, routeData: RouteLoadingData) {
    stateData.data.resolve = {};
    if (routeData.originalResolve) {
      Object.keys(routeData.originalResolve).forEach((key) => {
        stateData.data.resolve[key] = this.getResolveWrapper(routeData, key);
      });
    }
    stateData.data.resolve[loadPrerequisitesResolveKey] = this.getResolveWrapper(routeData, <string>undefined);
  }
}
